"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const IPOCPage_1 = __importDefault(require("./routes/IPOCPage"));
const Dashboard_1 = __importDefault(require("./routes/Dashboard"));
const ExercisesList_1 = require("./routes/ExercisesList");
const Landing_1 = require("./routes/Landing");
const SpeechDevelopment_1 = __importDefault(require("@app/routes/SpeechDevelopment"));
const SyllabicStructure_1 = __importDefault(require("@app/routes/SyllabicStructure"));
const store_js_1 = require("./store.js");
/**
 * Mapping of route names to corresponding React components.
 * Used to render the appropriate page based on the value stored in localStorage.
 *
 * @type {Object<string, JSX.Element>}
 */
const pageMap = {
    charts: react_1.default.createElement(Dashboard_1.default, null),
    ipoc: react_1.default.createElement(IPOCPage_1.default, null),
    landing: react_1.default.createElement(Landing_1.Landing, null),
    "exercises-list": react_1.default.createElement(ExercisesList_1.ExercisesList, null),
    "speechDevelopment": react_1.default.createElement(SpeechDevelopment_1.default, null),
    "syllable_structure": react_1.default.createElement(SyllabicStructure_1.default, null),
};
/**
 * App component renders the page based on the route stored in localStorage.
 *
 * @component
 * @example
 * // If localStorage has "charts", the Dashboard component will render
 * localStorage.setItem("reactRote", "charts");
 * <App />
 *
 * @returns {JSX.Element} The page corresponding to the stored route.
 */
const App = () => {
    // Get the current route from localStorage
    const path = localStorage.getItem("reactRote");
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_js_1.store },
        react_1.default.createElement("div", { id: "react-app", style: { width: '100%', height: '100%' } }, pageMap[path])));
};
exports.default = App;
